export default {
  setPublishUrl(state, publishUrl) {
    state.publishUrl = publishUrl
  },

  setLinkUserUrl(state, linkUserUrl) {
    state.linkUserUrl = linkUserUrl
  },

  setRedirectUrl(state, redirectUrl) {
    state.redirectUrl = redirectUrl
  },

  setOneClickModerationUrl(state, oneClickModerationUrl) {
    state.oneClickModerationUrl = oneClickModerationUrl
  },

  setValidationErrors(state, validationErrors) {
    state.validationErrors = validationErrors
  },

  setAuthenticationModalData(state, authenticationModalData) {
    state.authenticationModalData = Object.assign(state.authenticationModalData, authenticationModalData)
  },

  setDisplayMissingInfoModal(state, { value, requiredFields }) {
    state.displayMissingInfoModal = value
    state.missingInfoRequiredFields = requiredFields
  },

  setDisplayUserAccountCreationAwaitingEmailConfirmation(state, { value, userEmail }) {
    state.displayUserAccountCreationAwaitingEmailConfirmation = value
    state.userEmailAddressAwaitingConfirmation = userEmail
  },

  setDisplayVerifyMfaTokenModal(state, { value, mfaParameters }) {
    state.displayVerifyMfaTokenModal = value
    state.mfaParameters = mfaParameters
  },

  setDisplayAuthenticationModal(state, displayAuthenticationModal) {
    state.displayAuthenticationModal = displayAuthenticationModal
  },

  setDisplayAwaitingApprovalModal(state, displayAwaitingApprovalModal) {
    state.displayAwaitingApprovalModal = displayAwaitingApprovalModal
  },

  setCampaignAwaitingApproval(state, campaignAwaitingApproval) {
    state.campaignAwaitingApproval = campaignAwaitingApproval
  },

  setDisplayModerateOnPublishModal(state, displayModerateOnPublishModal) {
    state.displayModerateOnPublishModal = displayModerateOnPublishModal
  },

  setStaffLedCampaign: (state, newStaffLedCampaign) => {
    state.values.staffLedCampaign = newStaffLedCampaign

    // If the partnership selection field is present, clear its value since a staff-led
    // campaign can't belong to a partnership.
    // We use different property names for the petition and event stores
    if ((state.fields || state.allFields || []).includes('partnershipId')) {
      state.values.partnershipId = null
    }
  }
}
